import axios from 'axios';

export interface PushNotificationPayload {
	title: string;
	body?: string;
	icon?: string;
	badge?: string;
	actions?: any[];
	requireInteraction?: boolean;
}

export function getPushUserConsent() {
	return window.Notification ? Notification.permission : false;
}

export async function askPushUserConsent() {
	await Notification.requestPermission().then(consent => {
		if (consent !== 'granted') {
			console.error({
				name: 'Consent denied',
				message: 'You denied the consent to receive notifications',
				code: 0
			});
		}
	});
}

export async function sendPushNotification(userUid: string, msg: PushNotificationPayload) {
	await axios
		.post(`/api/notification/push/subscription/user/${userUid}`, createPushNotificationPayload(msg))
		.catch(err => {
			// something like: if (err.contains('status code 410')) navigator.permissions.remove(['notification']);
		});
}

export async function sendGroupPushNotification(groupUid: string, msg: PushNotificationPayload) {
	await axios
		.post(`/api/notification/push/subscription/group/${groupUid}`, createPushNotificationPayload(msg))
		.catch(err => {
			// something like: if (err.contains('status code 410')) navigator.permissions.remove(['notification']);
		});
}

const createPushNotificationPayload = (props: PushNotificationPayload) => {
	return {
		title: props.title,
		body: props.body,
		icon: props.icon ?? './logo-192x192.png',
		badge: props.badge ?? './logo-192x192.png',
		actions: props.actions,
		requireInteraction: props.requireInteraction
	};
};

export default {
	askPushUserConsent,
	getPushUserConsent,
	sendPushNotification,
	sendGroupPushNotification
};
